export const handleConvertNumberValue = ({ target: { value } }) => {
    if (/[^0-9]/g.test(value)) value = value.replace(/[^0-9]/g, "");
    return value;
};
